/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leads_NewInputs */

const cs_leads_new = /** @type {(inputs: Leads_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nový lead`)
};

const en_leads_new = /** @type {(inputs: Leads_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New lead`)
};

/**
* | output |
* | --- |
* | "New lead" |
*
* @param {Leads_NewInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const leads_new = /** @type {((inputs?: Leads_NewInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leads_NewInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_leads_new(inputs)
	return cs_leads_new(inputs)
});